import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BreadcrumbService } from './breadcrumb.service';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'tel-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  private readonly BREADCRUMB = 'breadcrumb';

  suscripciones: Subscription[];

  constructor(private router: Router, private rutaActivada: ActivatedRoute, private translateService: TranslateService, private breadcrumbService: BreadcrumbService, private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService) {
    this.suscripciones = [];
  }

  ngOnInit(): void {
    this.refrescarLiteralesBreadcrumbTrasNavegaciones();
    this.refrescarMarcasDeLugarBreadcrumBajoDemanda();

    this.suscripciones.push(
      this.translateService.onLangChange.subscribe(() => {
        this.actualizarBreadcrumbsDesdeCambioIdioma();
      })
    );
  }

  private actualizarBreadcrumbsDesdeCambioIdioma(): void {
    let breadcrumbs: Breadcrumb[] = this.obtenerBreamcrumb();
    breadcrumbs = this.traducirBreadcrumbs(breadcrumbs);
    this.actualizarBreadcrumb(breadcrumbs);
  }

  private obtenerBreamcrumb(): Breadcrumb[] {
    let nodo = this.rutaActivada.firstChild;
    while (nodo) {
      if (nodo.firstChild) {
        nodo = nodo.firstChild;
      } else if (nodo.snapshot.data && nodo.snapshot.data[this.BREADCRUMB]) {
        return nodo.snapshot.data[this.BREADCRUMB];
      } else {
        return null;
      }
    }
    return null;
  }

  private actualizarBreadcrumb(breadcrumbs: Breadcrumb[]): void {
    this.ngDynamicBreadcrumbService.updateBreadcrumb(breadcrumbs);
  }

  private refrescarLiteralesBreadcrumbTrasNavegaciones() {
    this.suscripciones.push(
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => {
            return this.obtenerBreamcrumb();
          }),
          map((breadcrumbs: Breadcrumb[]) => {
            return this.traducirBreadcrumbs(breadcrumbs);
          })
        )
        .subscribe((breadcrumbs: Breadcrumb[]) => {
          this.actualizarBreadcrumb(breadcrumbs);
        })
    );
  }

  private traducirBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    if (!breadcrumbs) {
      return null;
    }
    const breadcrumbsTraducidas: Breadcrumb[] = [];
    breadcrumbs.forEach((breadcrumb) => {
      breadcrumbsTraducidas.push({
        ...breadcrumb,
        label: this.traducirBreadcrumb(breadcrumb),
      });
    });

    return breadcrumbsTraducidas;
  }

  private traducirBreadcrumb(breadcrumb: Breadcrumb) {
    const regexpI18N = /\[\[(.*?)\]\]/gi;
    const labelTraducido = breadcrumb.label.replace(regexpI18N, (cadena, match) => {
      return this.translateService.instant(match);
    });
    return labelTraducido;
  }

  private refrescarMarcasDeLugarBreadcrumBajoDemanda() {
    this.suscripciones.push(
      this.breadcrumbService.cacheEtiquetasObservable.subscribe((etiquetasMarcasDeLugar) => {
        this.ngDynamicBreadcrumbService.updateBreadcrumbLabels(etiquetasMarcasDeLugar);
      })
    );
  }

  ngOnDestroy(): void {
    this.suscripciones.forEach((suscripcion) => suscripcion.unsubscribe());
  }
}
